import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getTeamRecordWithMeta } from '@sportninja/common/services/game/attendanceServices'

export interface TeamRecord {
  id: string
  name?: string
  image?: unknown
}

/**
 * GET /teams/:id — web-local copy of mobile's useTeamRecord, used here only to
 * resolve the header logo. Disabled when there is no teamId.
 */
export const useTeamRecord = (teamId?: string) => {
  const query = useQuery({
    queryKey: queryKeys.teamRecord.byId(teamId ?? ''),
    queryFn: () => getTeamRecordWithMeta(teamId as string),
    enabled: Boolean(teamId),
    staleTime: 5 * 60 * 1000,
  })

  return {
    data: query.data?.data as TeamRecord | undefined,
    isLoading: query.isLoading,
  }
}
